import { Component } from "@angular/core";

import { Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { TranslateService } from "@ngx-translate/core";
import { en_US, zh_CN, LocaleProviderService } from "ng-zorro-antd-mobile";
// import {JPush} from '@jiguang-ionic/jpush/ngx';
import { ChangTabService } from "./services/chang-tab.service";
import { NavController } from "@ionic/angular";

import { Router } from "@angular/router";
import { ProxySettingService } from "./services/proxy-setting/proxy-setting.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
})
export class AppComponent {
  local: any;

  showProxyName: any = false;
  proxyName: any = "";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public translateService: TranslateService,
    public localeProviderService: LocaleProviderService,
    // public jpush: JPush,
    public proxySettingService: ProxySettingService
  ) {
    this.checkProxyName();

    this.initializeApp();

    localStorage.setItem("appStatus", "1");

    localStorage.setItem("Zone", "Utc");

    // 从链接url中获取code,如果code存在，则放入localStorage中
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      localStorage.setItem("code", code);
    }

    let defaultLang = "zh";
    this.local = zh_CN;
    if (localStorage.getItem("defaultLang")) {
      defaultLang = localStorage.getItem("defaultLang");
      console.log("defaultLang is:" + defaultLang);
    }

    /* --- set i18n begin ---*/
    this.translateService.addLangs(["zh", "en"]);
    this.translateService.setDefaultLang(defaultLang);
    // const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(defaultLang);

    if (defaultLang === "en") {
      this.local = en_US;
    } else if (defaultLang === "zh") {
      this.local = zh_CN;
    } else {
      this.local = zh_CN;
    }
    this.localeProviderService.setLocale(this.local);
    /* --- set i18n end ---*/
  }

  initializeApp() {
    // localStorage.clear();
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // 初始化极光推送
      // console.log('极');
      // this.jpush.setDebugMode(true);
      // this.jpush.init();
      // 检查热更新
      this.checkUpgrade();
      // this.jpush.init().then(res => {
      //   console.log( '成功' + JSON.stringify(res));
      // }).catch(err => {
      //   console.log( '失败' + JSON.stringify(err));
      //   alert('失败！' + err);
      // });
      // console.log('初始化成功');
    });
  }

  checkProxyName() {
    this.proxySettingService.proxyName.subscribe((value) => {
      if (value !== "默认项") {
        this.showProxyName = true;
        this.proxyName = localStorage.getItem("proxyName");
      } else {
        this.showProxyName = false;
        this.proxyName = "";
      }
    });
  }

  checkUpgrade() {}

  installUpgrade() {}
}
